exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pro-visible .el-tag{max-width:200px}.scrollbar .el-table__body-wrapper::-webkit-scrollbar{width:1px}.scrollbar .el-table__body-wrapper::-webkit-scrollbar-thumb{background:#99a9bf;border-radius:5px}.user-tooltip{margin-left:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38a3c06b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order/list.vue
// module id = 1255
// module chunks = 0